import type {
  ListAllParams,
  ListPublishedParams,
} from "@/shared/blog/blogService.contract";
import type { ListTopicsParams } from "@/services/blog/topicsService.contract";
import type { ListSuggestionsParams } from "@/services/blog/suggestionsService.contract";
import type {
  BlogAnalyticsRange,
  ListPostAnalyticsParams,
  ListSearchStatsParams,
} from "@/shared/blog/analytics";

/** Chaves de cache centralizadas para o blog (backoffice + público). */
export const blogKeys = {
  all: ["blog"] as const,

  backofficeList: (params?: ListAllParams) =>
    ["blog", "backoffice", "posts", params ?? {}] as const,
  backofficeDetail: (id: string) => ["blog", "backoffice", "post", id] as const,
  // Debaixo de ["blog", ...]: salvar ou mudar status invalida `blogKeys.all`
  // e o checklist é recalculado sozinho.
  postChecks: (id: string) => ["blog", "backoffice", "post", id, "checks"] as const,

  publishedList: (params?: ListPublishedParams) =>
    ["blog", "public", "posts", params ?? {}] as const,
  publishedDetail: (slug: string) => ["blog", "public", "post", slug] as const,
  categories: () => ["blog", "public", "categories"] as const,

  // ── Clusters (E1.4) ───────────────────────────────────────────────────────
  clusters: () => ["blog", "backoffice", "clusters"] as const,
  authors: () => ["blog", "backoffice", "authors"] as const,
  publishedCluster: (slug: string) =>
    ["blog", "public", "cluster", slug] as const,

  // ── Pautas (E4.4) ─────────────────────────────────────────────────────────
  topics: (params?: ListTopicsParams) =>
    ["blog", "backoffice", "topics", params ?? {}] as const,

  // ── Sugestões de atualização (E7.3) ─────────────────────────────────────────
  suggestions: (params?: ListSuggestionsParams) =>
    ["blog", "backoffice", "suggestions", params ?? {}] as const,

  // ── Painel do CMO (E7.4) ─────────────────────────────────────────────────
  jobRuns: () => ["blog", "backoffice", "jobRuns"] as const,
  weeklyDigests: () => ["blog", "backoffice", "weeklyDigests"] as const,

  // ── Analytics (E8) ────────────────────────────────────────────────────────
  // O intervalo entra na chave: trocar o período é outra pergunta, e tem de
  // ser outro cache — senão o usuário vê 90 dias rotulado como 7.
  analyticsSummary: (range: BlogAnalyticsRange) =>
    ["blog", "backoffice", "analytics", "summary", range] as const,
  analyticsPosts: (params: ListPostAnalyticsParams) =>
    ["blog", "backoffice", "analytics", "posts", params] as const,
  analyticsTimeseries: (postId: string, range: BlogAnalyticsRange) =>
    ["blog", "backoffice", "analytics", "timeseries", postId, range] as const,
  analyticsSources: (range: BlogAnalyticsRange) =>
    ["blog", "backoffice", "analytics", "sources", range] as const,
  searchStats: (params: ListSearchStatsParams) =>
    ["blog", "backoffice", "searchStats", params] as const,
};
